/** localStorage: user opted out of the automated creator campaigns info modal before starting a new campaign. */
export const AUTOMATED_CREATOR_CAMPAIGNS_INFO_MODAL_DISMISSED_KEY =
  'automatedCreatorCampaignsInfoModalDismissed';
